export default __webpack_public_path__ + "static/media/shuttleIcon.357a5281.svg";